<template>
    <v-dialog persistent v-model="dialog" width="35%">
        <v-card min-height="150px">
            <v-container>
                <br>
                <v-row align-content="center" justify="center">
                    <v-col class="text-subtitle-1 text-center" cols="12">
                       {{this.text}}
                    </v-col>
                 </v-row>
                 <v-row v-if="showText" no-gutter align-content="center" justify="center">
                    <v-col class="text-center" cols="12">
                        {{this.progress.data}}
                    </v-col>
                 </v-row>
                 <v-row align-content="center" justify="center">
                    <v-col cols="6">
                        <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
                    </v-col>                    
                </v-row>
                <br>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {

        data () {
            return {
                dialog: false,
                dots: '',
                text: '',
                loopId: null,
                showText: false,
                progress: {},
            }
        },  
        methods: {
            open(param, showprogress, interval) {            
                this.text = param;
                this.progress = {};
                this.dialog = true;
                if(showprogress){
                    this.showText = true;
                    if(interval == null || interval == 0){
                        interval = 1000;
                    }
                    this.loopId = setInterval(() => { this.getProgress(); }, interval); 
                } else {
                    this.showText = false;
                    this.loopId = null;
                }

            },    
            close() {
                clearInterval(this.loopId);
                this.dialog = false;
            },
            getProgress() {
                this.$axios
                    .post("ares/json/ares/misc/showProgress.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "showProgress"
                        },
                        showProgress: {
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.progress = res.data.showProgress;
                            if (this.progress.data === 'ready') {                                
                                this.close();
                            }
                        }
                    });
            },            
        }        
    }
</script>

<style scoped>

</style>